// extracted by mini-css-extract-plugin
export default {"card":"CardMartiller_card__sr2Dm","header":"CardMartiller_header__FS+Mi","photo":"CardMartiller_photo__qgLuZ","name":"CardMartiller_name__vSWuK","link":"CardMartiller_link__9t-Tz"};